import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { FilterQuery } from "shared";

import { searchReliablesQuery } from "./searchReliables.query";

export const useSearchReliables = (
  {
    id,
    filtersParams,
    dimensionWeight,
  }: {
    id: string | undefined;
    filtersParams: FilterQuery;
    dimensionWeight?: number;
  },
  options?: { enabled?: boolean },
) => {
  const { data, ...rest } = useQuery({
    ...searchReliablesQuery(id, filtersParams, dimensionWeight),
    enabled: !!id && options?.enabled,
    placeholderData: keepPreviousData,
  });

  return { similarParts: data, ...rest };
};
